import React from 'react';

import styled from '@emotion/styled';
import {spacing} from '@nfq/react-grid';

import type {FilterConfig} from './FilterWrapper';

/**
 * Custom hook to manage the filter component within a dashboard or similar interface.
 *
 * @param filter An array of filter configurations that define the behavior and options for each filter component.
 * @returns An object containing the rendered filter component (`filterComp`) that can be used within the UI.
 */
export const useFilterWrapper = (filter: FilterConfig[]) => {
    const filterComp = (
        <InlineFilter>
            {filter.map(filterItem => {
                const Component = filterItem.component;

                if (['multi-select', 'single-select'].includes(filterItem.type)) {
                    return (
                        <Component
                            key={filterItem.name}
                            defaultValue={filterItem.defaultValue}
                            filterLabel={filterItem.label}
                            isMultiSelect={filterItem.type === 'multi-select'}
                            name={filterItem.name}
                            options={filterItem.options}
                            // eslint-disable-next-line react/jsx-handler-names
                            onChange={filterItem.onChange}
                        />
                    );
                } else if (filterItem.type === 'time-select') {
                    return (
                        <Component
                            key={filterItem.name}
                            filterLabel={filterItem.label}
                            popOverPosition="left"
                            // eslint-disable-next-line react/jsx-handler-names
                            onChange={filterItem.onChange}
                        />
                    );
                }

                return null;
            })}
        </InlineFilter>
    );

    return {filterComp};
};

const InlineFilter = styled.div`
    background-color: ${({theme}) => theme.colors.neutral0};
    border-radius: 10rem;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: ${spacing(6)};
    padding: ${spacing(2)} ${spacing(4.5)};
    width: fit-content;
`;